// extracted by mini-css-extract-plugin
export default {"pageHeading":"pageHeading-XSLVs","card":"card-yvOem","tabList":"tabList-p3gUx","tabPanel":"tabPanel-x80Tw","tabsSkeleton":"tabsSkeleton-K6PXT"};